import { FunctionComponent, useCallback, useMemo } from 'react'

import styled from 'styled-components'

import { SportEntitiesData, SportEntityType } from '@utils/entities'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import FollowMyTeamSportEntity from '@components/FollowMyTeam/FollowMyTeamSportEntity'

type FmTCompetitorsListProps = {
  competitorsListData: SportEntitiesData
}

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const FmTCompetitorsList: FunctionComponent<FmTCompetitorsListProps> = ({
  competitorsListData,
}) => {
  const onAddTeamClickEvent = useCallback<TrackingFnType<{ entityId: string }>>(
    ({ extraData }) => ({
      event: 'add_team',
      entity_id: extraData.entityId,
    }),
    [],
  )

  const trackedOnAddTeamClick = useTracking(onAddTeamClickEvent)

  const handleOnFollowClick = useCallback(
    (sportEntity: SportEntityType) => {
      trackedOnAddTeamClick({ entityId: sportEntity.entityId })
    },
    [trackedOnAddTeamClick],
  )
  const sportCompetitorsListContent = useMemo(
    () => (
      <StyledList>
        {competitorsListData?.map((competitor) => (
          <FollowMyTeamSportEntity
            key={competitor.entityId}
            sportEntity={competitor}
            onFollowClick={handleOnFollowClick}
          />
        ))}
      </StyledList>
    ),
    [competitorsListData, handleOnFollowClick],
  )

  return sportCompetitorsListContent
}

export default FmTCompetitorsList
